export const locale = {
    lang: 'pl',
    data: {
        'ADD': 'Dodaj',
        'description not provided': 'nie podano opisu',
        'Phone': 'Telefon',
        'Edit description': 'Edytuj opis',
        'description change': 'zmiana opisu',
        'SAVE': 'Zapisz',
        'Confirm': 'Potwierdź',
        'Cancel': 'Anuluj',
        'Take the card': 'Zabierz kartę',
        'Take the card from customer!': 'Zabierz kartę klientowi!',
        'Validation errors': 'Błędy walidacji',
        'Customer with provided first name and second name already exists!': 'Klient o podanym imieniu oraz nazwisku istnieje!',
        'Open bill found': 'Znaleziono otwarty rachunek',
        'Customer has to pay!': 'Klient musi zapłacić!',
        'Go to bill': 'Przejdź do rachunku',
    }
};
